import type { FaireProductEntity } from "../../entity_types/product";

export const p_a4e95eufqc: FaireProductEntity = {
  token: "p_a4e95eufqc",
  type: "product",
  name: "Varsity Stripes Set of 10 Pencils",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/7165d52f12c16514ecbdea46b75954538955b79985dc7dbb8041e8a5b91093ff.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/640f53a47c5bf7cad15e8f0ff753e221cbb16dde8cc0b604ef87bf0a908dab6a.jpeg",
    "https://cdn.faire.com/fastly/507131bc902165591e8f397697dd75572b159fb9c4110ca08ecfbee218cf70d8.jpeg",
    "https://cdn.faire.com/fastly/84453b364b7103a3d0082a3f7cc28a0efd41590dfa5aa9a1aa18de1067c39e3d.png",
  ],
  priceDollars: 8,
  description:
    "These pencils are cute, pretty and so good-looking they’re almost desk decorations, coming in an adorable little tube that slides open in the most satisfying way. The designs are fun, the points are sharp - these are sure to give you “new school supplies” butterflies again. If you haven’t used pencils since elementary school, get ready to feel 9 again (arguably with better handwriting). Set of 10 #2 pencils with erasers that actually work. Honestly, we might never use pens again!",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:29.292Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
